//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { SibaGridColumn, LargeScreenDialog, LoadingButton, MultiGrid, SmallScreenDialog, SibaSelect, ShowInfoConfirmation, SibaInput, SibaDatePicker } from "@siba/components";
import ModalForm from "./IssueReviewModalForm";
import React, { useEffect, useState } from "react";
import { useGenericFormMethods } from "Application/Pages/formMethods/genericMethods";
import SetupActionPanel from "Application/Components/Actions/SetupActionPanel";
import { IIssue } from "Application/features/models/Issue/IIssue";
import {
    useSaveReportMutation,
    useSearchReportMutation,
    useToggleReportStateMutation,
    useUpdateReportMutation,
    useGetAllReportMutation,
    useSearchConfirmedReportsMutation,
    useGetPendingReviewMutation
} from "Application/features/services/apis/Report/IssueApiService";
import { Button, Paper, Stack, Typography } from "@mui/material";
import { AlertTriangle, AlertCircle, ArrowDown, Briefcase, FileText } from "react-feather";
import { growlInfo, userManagementUtil } from "@siba/utilities";
import { useForm } from "react-hook-form";
import IssueReportForm from "../IssueForm/IssueForm";

import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
    checkboxGroup: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        marginBottom: "10px"
    },
    checkboxLabel: {
        display: "flex",
        alignItems: "center",
        marginRight: "20px",
        cursor: "pointer"
    },
    checkboxInput: {
        appearance: "none",
        marginRight: "5px",
        width: "16px",
        height: "16px",
        border: "1px solid #ccc",
        borderRadius: "3px",
        backgroundColor: "#fff",
        cursor: "pointer",
        position: "relative",
        "&:checked": {
            backgroundColor: "#2196f3",
            borderColor: "#2196f3"
        }
    },
    checkboxCheck: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "8px",
        height: "8px",
        borderRadius: "50%",
        backgroundColor: "#fff",
        display: "none",
        "&:after": {
            content: "''",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "4px",
            height: "4px",
            borderRadius: "50%",
            backgroundColor: "#2196f3",
            display: "block"
        },
        "&:checked:after": {
            display: "block"
        }
    },
    checkboxText: {
        fontSize: "16px",
        color: "#333",
        cursor: "pointer"
    }
});

/**
 * Main Form Component for Branch
 */

export default function IssueReview() {
    // const classes = useStyles();
    /**
     * Save  hook generated by @see BranchServiceApi
     * points to the save enpoint.
     */
    const [save] = useSaveReportMutation();

    /**
     * Update  hook generated by @see BranchServiceApi
     * points to the Update enpoint.
     */
    const [update] = useUpdateReportMutation();

    /***
     * Search  hook generated by @see BranchServiceApi
     * points to the Fetch enpoint.
     */
    const [search] = useSearchConfirmedReportsMutation();

    const [toggleState] = useToggleReportStateMutation();

    const [getPendingIssues] = useGetPendingReviewMutation();

    const [searchFilters, setSearchFilters] = useState("pendinginprogressresolved");
    const classes = useStyles();

    const handleCheckboxChange = (event: any) => {
        const value = event.target.value;
        if (event.target.checked) {
            setSearchFilters((prevValues) => prevValues + value);
        } else {
            setSearchFilters((prevValues) => prevValues.replace(value, ""));
        }
    };

    /**
     * genericMethods is generic method, property  generator tha returns
     * default/ generic event handlers for a setup form.
     * @prop Name is defaulted as the name of the setup and shown on the form.
     * @prop saveMethod - a save endpoint/ function for the setup.
     * @prop removeMethod - points to the remove method, endpoint for the setup.
     * @prop updateMethod - points to the update method / endpont for the setup.
     * @returns generic methods / properties for setup form.
     * @type IBranch
     * **/
    const genericMethods = useGenericFormMethods<IIssue>({
        formName: "Issue Review",
        saveMethod: save,
        updateMethod: update,
        searchMethod: search,
        isParent: true
    });

    const newIssueMethods = useGenericFormMethods<IIssue>({
        formName: "New Issue"
    });

    const gridRankingTemplate = (props: any): any => {
        switch ((props.priority || "").toLowerCase() as any) {
            case "high":
                return (
                    <>
                        <Paper style={{ backgroundColor: "lightcoral", color: "#fff", display: "flex", alignItems: "center", padding: "5px", borderRadius: "20px" }} elevation={1}>
                            <AlertTriangle color="grey" size={20} /> &nbsp; {props.priority}
                        </Paper>{" "}
                    </>
                );
            case "intermediate":
                return (
                    <>
                        <Paper style={{ backgroundColor: "peachpuff", color: "black", display: "flex", alignItems: "center", padding: "5px", borderRadius: "20px" }} elevation={1}>
                            <AlertTriangle color="grey" size={20} /> &nbsp; {props.priority}
                        </Paper>
                    </>
                );
            case "normal":
                return (
                    <>
                        <Paper style={{ backgroundColor: "lightgrey", color: "black", display: "flex", alignItems: "center", padding: "5px", borderRadius: "20px" }} elevation={1}>
                            <AlertTriangle color="grey" size={20} /> &nbsp; {props.priority}
                        </Paper>
                    </>
                );
            default:
                return (
                    <>
                        <Paper
                            className={""}
                            sx={{ height: "90%", width: "90%" }}
                            elevation={1}
                            style={{ backgroundColor: "#c4cccd", color: "#fff", display: "flex", alignItems: "center", padding: "5px", borderRadius: "20px" }}
                        >
                            <AlertCircle size={20} /> &nbsp; Unknown{" "}
                        </Paper>
                    </>
                );
        }
    };

    const gridStateTemplate = (props: any): any => {
        switch ((props.state || "").toLowerCase() as any) {
            case "resolved":
                return (
                    <>
                        <Paper style={{ backgroundColor: "lightgreen", color: "#fff", display: "flex", alignItems: "center", padding: "5px", borderRadius: "5px" }} elevation={1}>
                            &nbsp; Resolved
                        </Paper>{" "}
                    </>
                );
            case "ignored":
                return (
                    <>
                        <Paper style={{ backgroundColor: "peachpuff", color: "black", display: "flex", alignItems: "center", padding: "5px", borderRadius: "5px" }} elevation={1}>
                            Ignored &nbsp;
                        </Paper>
                    </>
                );
            case "completed":
                return (
                    <>
                        <Paper style={{ backgroundColor: "lawngreen", color: "black", display: "flex", alignItems: "center", padding: "5px", borderRadius: "5px" }} elevation={1}>
                            Completed
                        </Paper>
                    </>
                );
            case "inprogress":
                return (
                    <>
                        <Paper style={{ backgroundColor: "lightblue", color: "black", display: "flex", alignItems: "center", padding: "5px", borderRadius: "5px" }} elevation={1}>
                            In Progrerss
                        </Paper>
                    </>
                );
            default:
                return (
                    <>
                        <Paper
                            className={""}
                            sx={{ height: "90%", width: "90%" }}
                            elevation={1}
                            style={{ backgroundColor: "#c4cccd", color: "#fff", display: "flex", alignItems: "center", padding: "5px", borderRadius: "5px" }}
                        >
                            Pending
                        </Paper>
                    </>
                );
        }
    };

    const getOptionalColumn = () => {
        if (userManagementUtil.getUserSession()?.companyName == "SIBA") {
            return { field: "companyName", headerText: "Company", width: 150 };
        } else {
            return { field: "", headerText: "", width: 50 };
        }
    };
    const gridCollumnDefinition: SibaGridColumn[] = [
        // {
        //     field: "profileImageLink",
        //     headerText: "Picture",
        //     width: 150,
        //     template: imageDisplayGridTemplate
        // },
        getOptionalColumn(),

        { field: "applicationName", headerText: "Application", width: 150 },

        {
            field: "subject",
            headerText: "Subject",
            width: 300
        },
        { field: "category", headerText: "Category", width: 150 },

        { field: "reportedBy", headerText: "Reported By", width: 150 },
        { field: "priority", headerText: "Priority", width: 150, template: gridRankingTemplate },
        { field: "state", headerText: "state", width: 150, template: gridStateTemplate },
        { field: "assignee", headerText: "Assigned to", width: 150 },
        { field: "dueDate", headerText: "Due Date", width: 150 },

        { field: "expectedResolutionDate", headerText: "Expected Date", width: 150 }
    ];
    /*
     * Handle fetch cities on tab click;
     */

    /***
     * Report status  toggle section.
     *
     */

    const [viewToggleSelector, setViewToggleSelector] = useState<boolean>(false);

    const [selectedRecords, setSelectedRecords] = useState([] as IIssue[]);

    const handleViewToggleSelector = () => {
        if (!selectedRecords.length) return growlInfo("Please select one or more records from the grid.");

        setViewToggleSelector(true);
    };

    const toggleFormHandler = useForm();
    const comfirmStateChange = async () => {
        if (!selectedRecords.length) return growlInfo("Please select one or more records from the grid.");
        ShowInfoConfirmation("Are you sure you want to change the state of the selected items", async () => {
            await toggleFormHandler.handleSubmit(
                async (data) => {
                    const response: any = await toggleState({ data: selectedRecords, state: data.state as any });

                    if (response && response.data) {
                        genericMethods.setModelCollection([...(response.data || []), ...genericMethods.modelCollection]);
                        setViewToggleSelector(false);
                    }
                },
                (_) => {
                    return growlInfo("please select required state");
                }
            )();
        });
    };

    const assignmentMethods = useGenericFormMethods({});
    const comfirmAssignment = async () => {
        if (!selectedRecords.length) return growlInfo("Please select one or more records from the grid.");
        ShowInfoConfirmation("Are you sure you want to assign selected issues?", async () => {
            await assignmentMethods.formHandler.handleSubmit(
                async (data) => {
                    let valid = true;
                    let updatedRecords: IIssue[] = selectedRecords;
                    for (let rec of updatedRecords) {
                        rec.assignee = data.assignee;
                        rec.dueDate = data.dueDate;
                        rec.modifiedBy = userManagementUtil.getUserCode();
                        rec.modifiedDate = new Date().toJSON();
                        const response: any = await update(rec);

                        if (response && response.data) {
                            genericMethods.setModelCollection([rec, ...genericMethods.modelCollection]);
                        } else {
                            valid = false;
                        }
                    }

                    if (valid) {
                        assignmentMethods.handleClickClose();
                    }
                },
                (_) => {
                    return growlInfo("please select required state");
                }
            )();
        });
    };

    /***
     *
     * fetch pending review items.
     */

    const handleFetchPendingReview = async () => {
        const userInfo = userManagementUtil.getUserSession();

        var data = {} as any;
        if (!((userInfo.companyName || "") == "SIBA")) {
            data.organisationId = userInfo.companyId;
        }
        const response: any = await getPendingIssues(data);

        if (response && response.data) {
            genericMethods.setModelCollection(response.data);
        }
    };

    useEffect(() => {
        handleFetchPendingReview();
    }, []);

    return (
        <React.Fragment>
            {/* <CustomizeBreadCrums /> */}
            <h5
                style={{
                    fontWeight: "500",
                    color: "rgba(0,0,0,0.6)",
                    padding: "10px 0"
                }}
            >
                Review Issues
            </h5>

            <SetupActionPanel clickSearch={genericMethods.handleModelSearch} hideButtons hiddenSearchParams={[{ name: "filter", value: searchFilters }]}>
                <div style={{ display: "flex", justifyContent: "end", width: "100%", alignItems: "center" }}>
                    <div style={{ display: "flex" }}>
                        <div style={{ marginRight: "10px", border: "0px solid #d5d5d5", borderRadius: "5px" }}>
                            <Button variant="contained" color="info" onClick={newIssueMethods.handleClickOpen} endIcon={<FileText size={12} />}>
                                Report New Issue
                            </Button>
                        </div>
                        <div style={{ marginRight: "10px", border: "0px solid #d5d5d5", borderRadius: "5px" }}>
                            <LoadingButton id="endorsementSummary" backgroundColor="primary" onClick={genericMethods.handleClickView}>
                                {" "}
                                View Issue Detail
                            </LoadingButton>
                        </div>
                        <div style={{ marginRight: "10px", border: "0px solid #d5d5d5", borderRadius: "5px" }}>
                            <Button variant="contained" color="secondary" onClick={handleViewToggleSelector} endIcon={<ArrowDown size={12} />}>
                                Change Issue State
                            </Button>
                        </div>

                        <div style={{ marginRight: "10px", border: "0px solid #d5d5d5", borderRadius: "5px" }}>
                            <Button variant="contained" color="primary" onClick={assignmentMethods.handleClickOpen} endIcon={<Briefcase size={12} />}>
                                Assign Issue
                            </Button>
                        </div>
                    </div>
                </div>
            </SetupActionPanel>
            <div className="row" style={{ margin: "0.4em" }}>
                <div className={classes.checkboxGroup}>
                    <label className={classes.checkboxLabel}>
                        <input type="checkbox" value="completed" className={classes.checkboxInput} onChange={handleCheckboxChange} checked={searchFilters.includes("completed")} />
                        <span className={classes.checkboxText}>Completed</span>
                    </label>
                    <label className={classes.checkboxLabel}>
                        <input type="checkbox" value="resolved" className={classes.checkboxInput} onChange={handleCheckboxChange} checked={searchFilters.includes("resolved")} />
                        <span className={classes.checkboxText}>Resolved</span>
                    </label>
                    <label className={classes.checkboxLabel}>
                        <input type="checkbox" value="inprogress" className={classes.checkboxInput} onChange={handleCheckboxChange} checked={searchFilters.includes("inprogress")} />
                        <span className={classes.checkboxText}>In Progress</span>
                    </label>
                    <label className={classes.checkboxLabel}>
                        <input type="checkbox" value="pending" className={classes.checkboxInput} onChange={handleCheckboxChange} checked={searchFilters.includes("pending")} />
                        <span className={classes.checkboxText}>Pending</span>
                    </label>
                    <label className={classes.checkboxLabel}>
                        <input type="checkbox" value="ignored" className={classes.checkboxInput} onChange={handleCheckboxChange} checked={searchFilters.includes("ignored")} />
                        <span className={classes.checkboxText}>Ignored</span>
                    </label>
                </div>
                <Typography variant="body1"> Click Search button to search with filter</Typography>
            </div>
            <MultiGrid
                data={genericMethods.modelCollection}
                onRowClick={(e) => {
                    genericMethods.formHandler.reset({});

                    genericMethods.setModel(e.row);
                    genericMethods.formHandler.reset(e.row);
                    console.log(e.row);
                }}
                onDoubleClick={genericMethods.gridDoubleClickModalResponse}
                onRowMultiSelection={(e) => setSelectedRecords(e.selectedRows)}
                columns={gridCollumnDefinition}
                id={""}
            />

            <LargeScreenDialog
                title={genericMethods.modalTitle}
                onClose={genericMethods.handleClickClose}
                visible={genericMethods.modalOpen}
                onSave={genericMethods.handleSave(genericMethods.saveType)}
                confirmationButtonText={"Update"}
            >
                <ModalForm model={genericMethods.model} formHandler={genericMethods.formHandler} disableFieldUpdate={genericMethods.saveType == "update"} saveMethod={undefined} />
            </LargeScreenDialog>
            <SmallScreenDialog
                title={"Select status of Issue"}
                visible={viewToggleSelector}
                onClose={() => {
                    setViewToggleSelector(false);
                }}
                confirmationButtonText="Apply New State"
                onSave={comfirmStateChange}
            >
                <div style={{ minHeight: "9em" }}>
                    <Stack direction="column" spacing={2} padding={3}>
                        <SibaSelect
                            formHandler={toggleFormHandler}
                            name="state"
                            label="New State"
                            optionsObj={[
                                {
                                    label: "Ignored",
                                    value: "Ignored"
                                },
                                {
                                    label: "Pending",
                                    value: "Pending"
                                },
                                {
                                    label: "In Progress",
                                    value: "InProgress"
                                },
                                {
                                    label: "Resolved",
                                    value: "Resolved"
                                },
                                {
                                    label: "Completed",
                                    value: "Completed"
                                }
                            ]}
                            validationObj={{ required: true }}
                        />
                    </Stack>
                </div>
            </SmallScreenDialog>
            <LargeScreenDialog
                title={"Select status of report"}
                visible={newIssueMethods.modalOpen}
                onClose={() => {
                    newIssueMethods.setOpen(false);
                }}
            >
                <IssueReportForm />
            </LargeScreenDialog>
            <SmallScreenDialog
                title={"Assign Selected Issues"}
                visible={assignmentMethods.modalOpen}
                onClose={assignmentMethods.handleClickClose}
                confirmationButtonText="Assign Issues"
                onSave={comfirmAssignment}
            >
                <div className={`row `} style={{ padding: "2em", height: "15em" }}>
                    <div className="col-sm-6">
                        <SibaInput name="assignee" label="Assign to" type="text" validationObj={{ required: true }} formHandler={assignmentMethods.formHandler} />
                    </div>
                    <div className="col-sm-4">
                        {" "}
                        <SibaDatePicker name="dueDate" label="Due Date" formHandler={assignmentMethods.formHandler} />
                    </div>
                </div>
            </SmallScreenDialog>
        </React.Fragment>
    );
}
